"use client";

import React, { useState } from "react";
const farmImages = [{
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8569.png",
  alt: "Ферма MONA и иппотерапия",
  label: "Иппотерапия и природная среда"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8570.png",
  alt: "Пространство фермы MONA",
  label: "Открытое пространство и прогулочные зоны"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8568.png",
  alt: "Живая среда фермы",
  label: "Живой сенсорный и эмоциональный опыт"
}];
export default function FarmSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prevSlide = () => {
    setActiveIndex(prev => prev === 0 ? farmImages.length - 1 : prev - 1);
  };
  const nextSlide = () => {
    setActiveIndex(prev => prev === farmImages.length - 1 ? 0 : prev + 1);
  };
  return <section id="farm" className="relative overflow-hidden bg-cover bg-center bg-no-repeat px-6 py-24 text-slate-950 md:px-12 md:py-28" style={{
    backgroundImage: "url('https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8569.png')"
  }}>
      <div className="absolute inset-0 bg-[#f3f0e6]/28" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(236,240,226,0.46)_0%,rgba(238,240,227,0.22)_30%,rgba(244,241,232,0.30)_100%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(150,166,126,0.18)_0%,rgba(255,255,255,0.02)_22%,rgba(210,214,186,0.12)_56%,rgba(242,238,226,0.28)_100%)]" />

      <div className="pointer-events-none absolute inset-0">
        <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-[#d9dbc7]/40 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-80 w-80 rounded-full bg-[#9aa67e]/25 blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 inline-flex items-center rounded-full border border-white/45 bg-white/30 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-700 shadow-[0_8px_24px_rgba(15,23,42,0.06)] backdrop-blur-md sm:text-xs">
            Ферма
          </div>

          <h2 className="mb-6 font-default text-3xl font-bold tracking-[-0.03em] text-slate-950 sm:text-4xl md:text-5xl">
            Ферма — <span className="text-[#166534]">вторая среда развития</span>
          </h2>

          <div className="space-y-4 font-default text-lg leading-relaxed text-slate-800">
            <p>
              Ферма — это не просто отдельная локация с животными, а пространство,
              где ребёнок получает природную, сенсорную и эмоциональную среду,
              которую невозможно полностью воссоздать в городе.
            </p>
            <p>
              Здесь развитие происходит через контакт с природой, животными,
              открытым пространством и живыми ритмами среды.
            </p>
            <p>
              Такая локация помогает ребёнку становиться спокойнее, устойчивее,
              увереннее и свободнее во взаимодействии с миром.
            </p>
          </div>
        </div>

        <div className="mb-10 overflow-hidden rounded-[36px] border border-white/45 bg-white/28 shadow-[0_16px_46px_rgba(15,23,42,0.08)] backdrop-blur-md">
          <div className="relative">
            <img src={farmImages[activeIndex].src} alt={farmImages[activeIndex].alt} className="h-[360px] w-full object-cover md:h-[500px]" />

            <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-[linear-gradient(to_top,rgba(15,23,42,0.68),transparent)] p-6">
              <div>
                <p className="text-sm font-medium uppercase tracking-[0.18em] text-white/70">
                  Пространство фермы
                </p>
                <p className="mt-2 font-default text-xl font-semibold text-white">
                  {farmImages[activeIndex].label}
                </p>
              </div>

              <div className="flex gap-3">
                <button type="button" onClick={prevSlide} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition-all hover:bg-white/20" aria-label="Предыдущее фото">
                  ‹
                </button>
                <button type="button" onClick={nextSlide} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition-all hover:bg-white/20" aria-label="Следующее фото">
                  ›
                </button>
              </div>
            </div>
          </div>

          <div className="flex gap-3 overflow-x-auto px-6 py-5">
            {farmImages.map((image, index) => <button key={image.src} type="button" onClick={() => setActiveIndex(index)} className={`shrink-0 overflow-hidden rounded-[20px] border transition-all ${activeIndex === index ? "border-[#166534] shadow-[0_10px_24px_rgba(22,101,52,0.14)]" : "border-white/45"}`}>
                <img src={image.src} alt={image.alt} className="h-20 w-28 object-cover" />
              </button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 xl:grid-cols-2">
          <div className="rounded-[36px] border border-white/45 bg-white/30 p-8 shadow-[0_16px_46px_rgba(15,23,42,0.08)] backdrop-blur-md md:p-10">
            <h3 className="mb-6 font-default text-2xl font-semibold tracking-[-0.03em] text-slate-950">
              Что включает территория
            </h3>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {["зона иппотерапии", "верховая езда", "мини-ферма с домашними животными", "обучающий огород", "зона отдыха", "прогулочные территории"].map(item => <div key={item} className="flex items-start gap-3 rounded-[24px] border border-white/45 bg-white/34 px-5 py-4 shadow-[0_6px_18px_rgba(15,23,42,0.05)] backdrop-blur-md">
                  <span className="mt-1 text-[#166534]">•</span>
                  <span className="font-default text-[15px] leading-7 text-slate-700">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="rounded-[36px] border border-white/45 bg-white/30 p-8 shadow-[0_16px_46px_rgba(15,23,42,0.08)] backdrop-blur-md md:p-10">
            <h3 className="mb-6 font-default text-2xl font-semibold tracking-[-0.03em] text-slate-950">
              Почему природа важна
            </h3>

            <div className="space-y-4">
              {["контакт с животными помогает развивать эмоциональную устойчивость и доверие", "открытое пространство снижает напряжение и даёт ребёнку больше свободы в движении", "сенсорный опыт природы помогает лучше регулировать состояние и внимание", "живая среда делает развитие более естественным и вовлекающим", "ребёнок получает опыт взаимодействия с миром вне привычных рамок помещения"].map(item => <div key={item} className="flex items-start gap-3 rounded-[24px] border border-white/45 bg-white/34 px-5 py-4 shadow-[0_6px_18px_rgba(15,23,42,0.05)] backdrop-blur-md">
                  <span className="mt-1 text-[#166534]">✓</span>
                  <span className="font-default text-[15px] leading-7 text-slate-700">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="mt-8 rounded-[28px] border border-[#b9b08b]/30 bg-[#d9d1b7]/28 p-6">
              <p className="font-default text-base leading-7 text-slate-700">
                Ферма дополняет работу основного центра и даёт ребёнку ту часть
                опыта, которая особенно важна для сенсорной, эмоциональной и
                социальной устойчивости.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}